import { render, staticRenderFns } from "./AVehicleCharts.vue?vue&type=template&id=63a71662&scoped=true"
import script from "./AVehicleCharts.vue?vue&type=script&lang=js"
export * from "./AVehicleCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a71662",
  null
  
)

export default component.exports